export default "__VITE_ASSET__CHVk0UO1__"